<div class="row title">
   <h3 class="ml-4">Dashboard / <span>Add New Apartment</span></h3>
 </div>
 <!-- <div class="container-fluid"> -->
 
 <div class="rk-ui-notification" style="z-index: 4444 !important" *ngIf="successError">
	<span id="notificationMessageText">{{ successMessage }}</span>
	<a class="close rk-linknotification" (click)="successError = false">×</a>
  </div>
  <div class="rk-ui-notification err" style="z-index: 4444 !important" *ngIf="msgError">
	<span id="notificationMessageText">{{ errorMessage }}</span>
	<a class="close rk-linknotification" (click)="msgError = false">×</a>
  </div>
 
 
 
 
 <div class="row p-3 justify-content-center internalPageBodyContent2">
    
   <div class=" px-5 py-3 col-md-offset-2 form_container mb-3">
 
    <div class="col-md-6">				
       <img class="cursor-pointer" (click)="back()" src="../../../../assets/img/arrow_left.svg" style="width: 15px">
    </div>
     
      <!-- <button class="button button_emi" (click) = "back()"> BACK TO Apartment DATA</button> -->
      <!-- <div class="alert alert-success text-center mt-2" *ngIf="successMessage">{{successMessage}}</div>
         <div class="alert alert-danger text-center mt-2" *ngIf="errorMessage">{{errorMessage}}</div> -->
      <div class="">
         <div class="card-content my-2 mx-2">
            <div class="tab-content">
               <div class="tab-pane active">
                  <form [formGroup]="createApartmentForm" (ngSubmit)="onSubmit(createApartmentForm.value); createApartmentForm.reset();" class="form-horizontal">
                  <!-- <fieldset formArrayName="apa"> -->
                  <div class="row">
                     <!--For Apartment Name-->   
                     <div class="col-md-6">
                        <div class="form-group label-floating" >
                           <label class="Label_style">Apartment Name<span class="astric">*</span></label>
                          
                           <div class="form-check" (mouseleave)="hideOptions()" (mouseenter)="showOptions()">
                            <input type="text" min=0 class="form-control" placeholder="Type to search..." (keyup)="searchSocietyApi($event)"  formControlName="apartment_name" style="border:1px solid #7E7E7E">
                           
                            <ul  class="adressSelect" *ngIf="createApartmentForm.controls['apartment_name'].value && createApartmentForm.controls['apartment_name'].value != '' && isApifired " >
                              <li *ngFor="let option of filteredOptions " (click)="selectOption(option)"><span class="d-inline-block h-100"><i class="fa fa-map-marker pr-1" aria-hidden="true" style="
                                font-size: 22px;vertical-align: middle; "></i></span> <span class="d-inline-block ml-1">{{ option.apartment_name }} {{ option.address }}</span>
                                </li>
                                <li *ngIf="!isSelected"   >
                                  <span class="d-inline-block h-100">
                                  <i class="fa fa-map-marker pr-1" aria-hidden="true" style="
                                font-size: 22px;vertical-align: middle; "></i></span> <span class="d-inline-block ml-1"> Could not find your property? <br>
                                 <button class="btn-pink px-3 py-2 mt-2" style="border-radius: 20px;border: solid;" (click)="selectOption('other')"> Add Property Details</button></span>
                                </li>
                            </ul>
                          
                            
                          </div>
                        </div>
                     </div>
                     <!--For Cluster-->   
                     <div class="col-md-6">
                        <div class="form-group label-floating" >
                           <label class="Label_style">Cluster</label>
                           <input type="text" min=0 class="text_box_style form-control" placeholder="Enter Cluster"  formControlName="cluster">
                        </div>
                     </div>
                     <!--For Apartment Address--> 
                     <div class="d-flex  w-100">
 
                      <div class="col-md-6">
                         <div class="form-group label-floating" >
                            <label class="Label_style">Apartment Addess<span class="astric">*</span></label>
                            <textarea  class=" form-control textarea_style" disabled rows="6" cols="50" placeholder=" Enter Apartment Addess "  formControlName="apartment_address" >
                            
                          </textarea>
                         </div>
                      </div>
                      <div class="col-md-6">
                         <div class="form-group label-floating" >
                            <label class="Label_style">Pin Code<span class="astric">*</span></label>
                            <input type="number" min=0 class="text_box_style form-control" placeholder="Enter Pin Code" disabled formControlName="pincode" onKeyPress="if(this.value.length==6) return false;" pattern="[0-9]{6}">
                         </div>
 
                         <div class="form-group label-floating" >
                            <label class="Label_style">UNID<span class="astric">*</span></label>
                            <input type="text" min=0 class="text_box_style  form-control" placeholder="Enter UNID" id="UNID" (keyup)="ToUpper()" formControlName="unid" onKeyPress="if(this.value.length==15) return false;" [ngStyle]="{'border':createApartmentForm.get('unid').hasError('required') && createApartmentForm.get('unid').touched ? '1px solid red' : '1px solid #c7c7c7'}">
                            <p class="astric bottom-note mb-0 notValid pl-2"
                            *ngIf="createApartmentForm.get('unid').touched && createApartmentForm.controls['unid'].value.length !== 15">
                            Please enter Min 15 Characters
                          </p>
                         </div>
 
 
 
                      </div>
 
                     </div>  
                    
                     <!-- For Pin Code-->  
                   
                     <!--Select City-->
                     <div class="col-md-6">
                        <div class="form-group label-floating">
                           <label class="Label_style">Search For State<span class="astric">*</span></label>
                           <input type="text" class="text_box_style form-control" disabled formControlName="state">
                           <!-- <ng-select
                           placeholder="Search For State"
                           class=" "
                           formControlName="state"
                           (change)="getscityList($event)">
                           <ng-option *ngFor="let state of states" [value]="state.state_code">{{
                           state.name | titlecase
                           }}</ng-option>
                           </ng-select> -->
                        </div>
                     </div>
                     <!--Select City-->
                     <div class="col-md-6">
                        <div class="form-group label-floating">
                           <label class="Label_style">Search For City<span class="astric">*</span></label>
                           <input type="text" class="text_box_style form-control" disabled formControlName="city">
 
                           <!-- <ng-select
                              placeholder="Search For City"
                              class=" "
                              formControlName="city">
                              <ng-option *ngFor="let city of city_list" [value]="city">{{
                              city | titlecase
                              }}</ng-option>
                           </ng-select> -->
                        </div>
                     </div>
                     <!--UNID-->
                    
                    
                     <!--Area Name-->
                     <div class="col-md-6">
                        <div class="form-group label-floating" >
                           <label class="Label_style">Area Name<span class="astric">*</span></label>
                           <input type="text" min=0 class="text_box_style form-control" placeholder="Enter Area"  formControlName="area_name">
                        </div>
                     </div>
                     <!--Select Lifestage-->
                     <div class="col-md-6">
                        <div class="form-group label-floating" >
                           <label class="Label_style">Lifestage<span class="astric">*</span></label>
                           <select class="text_box_style form-control text-capitalize" formControlName="lifestage">
                              <option value=""  disabled  selected>Select Lifestage</option>
                              <option class="text-capitalize" *ngFor="let v of lifeStage" value="{{v}}">{{v}}</option>
                           </select>
                        </div>
                     </div>
                     <!--Select Theme-->
                     <div class="col-md-6">
                        <div class="form-group label-floating" >
                           <label class="Label_style">Theme<span class="astric">*</span></label>
                           <select class="text_box_style form-control text-capitalize" formControlName="theme">
                              <option value=""  disabled  selected>Select Theme</option>
                              <option class="text-capitalize" *ngFor="let v of theme" value="{{v}}">{{v}}</option>
                           </select>
                        </div>
                     </div>
                     <!--Developer Name-->
                     <div class="col-md-6">
                        <div class="form-group label-floating" >
                           <label class="Label_style">Developer Name<span class="astric">*</span></label>
                           <input type="text" min=0 class="text_box_style form-control" placeholder="Enter Developer Name"  formControlName="developer_name">
                        </div>
                     </div>
                     <div class="col-md-3">
                        <div class="form-group label-floating">
                           <label class="Label_style">Start From<span class="astric">*</span></label>
                           <input type="number" min=0 class="text_box_style form-control" placeholder="Enter Start From" formControlName="start_from">
                        </div>
                     </div>
                     <div class="col-md-3">
                        <div class="form-group label-floating">
                           <label class="Label_style">Apartment Value<span class="astric">*</span></label>
                           <input type="number" min=0 class="text_box_style form-control" placeholder="Enter Apartment Value" formControlName="apartment_value">
                        </div>
                     </div>
                     <div class="col-md-3">
                        <div class="form-group label-floating">
                           <label class="Label_style">Apartment Area<span class="astric">*</span></label>
                           <input type="number" min=0 class="text_box_style form-control" placeholder="Enter Apartment Area" formControlName="area">
                        </div>
                     </div>
 
 
                     <div class="col-md-3">
                        <div class="form-group label-floating">
                           <label class="Label_style">BOQ EMI<span class="astric">*</span></label>
                           <input type="number" min=0 class="text_box_style form-control" placeholder="Enter EMI" formControlName="boq_emi">
                        </div>
                     </div>
                    
                     <!--Format with varient id and layout image-->
                     <div class="col-md-12">
                        <fieldset formArrayName="formats"
                           >
                           <div class="row mt-3" *ngFor="let item of createApartmentForm.get('formats')['controls']; let i = index;" [formGroup]="item">
                           <div class="card ml-3 w-100 format_con p-4" >
                              <div class="container-fluid">
                                 <!--Select Format-->      
                                 <div class="col-md-4 mt-3">
                                    <div class="form-group label-floating" >
                                       <label class="Label_style">Select Format<span class="astric">*</span></label>
                                       <select class="text_box_style form-control text-capitalize" formControlName="name">
                                          <option value=""  disabled  selected>Select Format</option>
                                          <option class="text-capitalize" *ngFor="let v of formatData" value="{{v}}">{{v}}</option>
                                       </select>
                                    </div>
                                 </div>
                                 <!--Select Format Ends Here-->
                                 <!--Variant Data Format-->
                                 <div class="col-md-12">
                                    <div class="card mb-3 varient_con mt-4 w-100 p-4" >
                                       <div class="container-fluid">
                                          <fieldset formArrayName="variants">
                                             <div class="row  pb-3 pt-3" *ngFor="let player of item.get('variants')['controls']; let j = index;" [formGroup]="player">
                                             <div class="col-md-8">
                                                <div class="form-group label-floating" >
                                                   <label class="Label_style">Variant ID<span class="astric">*</span></label>
                                                   <input type="text" min=0 class="text_box_style form-control w-50" placeholder="Enter Variant ID"  formControlName="variant_id" onKeyPress="if(this.value.length==6) return false;">
                                                </div>
                                             </div>
 
 
                                           <div class="col-md-6">
                                              <label class="mb-2 Label_style">Select Layout Floor Plan<span class="astric">*</span></label>
                                              <div class="input-group">
                                                <input id="fileNamePreset{{i}}{{j}}"   class="form-control preset-zip-file-upload" readonly (click)="filePicker.click()"    aria-label="Recipient's username" aria-describedby="basic-addon2" style="background-color: white;">
                                                <div class="input-group-append">
                                                 <button class="btn cursor-pointer btn-burgntee px-5 font-weight-bold choose-file-btn" (click)="filePicker.click()" type="button">Upload</button>
                                                </div>
                                                <input  #filePicker (change)="onChange($event,i,j)" type="file"   class="form-control-file d-none" >
                                              </div>
                                              <img class="image"  src ="{{item.get('variants').controls[j].controls['layout_image'].value}}" onerror="src='../../../assets/img/default-apartment.png'" width="200" height="200" *ngIf="item.get('variants').controls[j].controls['layout_image'].value" >
                                           </div>
 
 
                                             <!-- <div class="col-md-6">
                                                <div class="form-group label-floating">
                                                   <label class="Label_style">Select Layout Floor Plannn<span class="astric">*</span></label>
                                                   <input type="file"  (change)="onChange($event,i,j)" class="text_box_style form-control border-0" [attr.id]="'attachment_file'+i+j" [name]="'attachment_file'+i+j" hidden >
                                                   <div class="col-md-12 uploadStyle">
                                                    <div class="col-md-7 imgStyle">{{item.get('variants').controls[j].controls['layout_imgagefilename'].value?item.get('variants').controls[j].controls['layout_imgagefilename'].value : 'Upload Image'}}</div>
                                                    <div class="col-md-4 uploadBtn">
                                                       <label class="labelStyle2" for="{{'attachment_file'+i+j}}">Upload</label>
                                                    </div>
                                                 </div>
                                                 <img class="image"  src ="{{item.get('variants').controls[j].controls['layout_image'].value}}" onerror="src='../../../assets/img/default-apartment.png'" width="200" height="200" *ngIf="item.get('variants').controls[j].controls['layout_image'].value" >
                                                </div>
                                             </div> -->
 
 
 
                                             <!-- <div class="col-md-6">
                                                <div class="form-group label-floating">
                                                   <label class="Label_style">Select Primary Image<span class="astric">*</span></label>
                                                   <input type="file" (change)="onChangeImage($event,i,j)" class="text_box_style form-control border-0" [attr.id]="'attachment_file2'+i+j" name="attachment_file2" hidden >
                                                   <div class="col-md-12 uploadStyle">
                                                    <div class="col-md-7 imgStyle">{{item.get('variants').controls[j].controls['primary_imagefilename'].value?item.get('variants').controls[j].controls['primary_imagefilename'].value : 'Upload Image'}}</div>
                                                    <div class="col-md-4 uploadBtn">
                                                       <label class="labelStyle2" for="{{'attachment_file2'+i+j}}">Upload</label>
                                                    </div>
                                                 </div>
                                                 <img class="image"  src ="{{item.get('variants').controls[j].controls['primary_image'].value}}" onerror="src='../../../assets/img/default-apartment.png'" width="200"  height="200" *ngIf="item.get('variants').controls[j].controls['primary_image'].value" >
                                                </div>
                                             </div> -->
 
                                           <div class="col-md-6">
                                              <label class="mb-2 Label_style ">Select Primary Image<span class="astric">*</span></label>
                                              <div class="input-group">
                                                <input id="fileNamePresetone{{i}}{{j}}"   class="form-control preset-zip-file-upload" readonly (click)="filePickerone.click()"  aria-label="Recipient's username" aria-describedby="basic-addon2" style="background-color: white;">
                                                <div class="input-group-append">
                                                 <button class="btn cursor-pointer btn-burgntee px-5 font-weight-bold choose-file-btn" (click)="filePickerone.click()" type="button">Upload</button>
                                                </div>
                                                <input  #filePickerone (change)="onChangeImage($event,i,j)" type="file"   class="form-control-file d-none" >
                                              </div>
                                              <img class="image"  src ="{{item.get('variants').controls[j].controls['primary_image'].value}}" onerror="src='../../../assets/img/default-apartment.png'" width="200"  height="200" *ngIf="item.get('variants').controls[j].controls['primary_image'].value" >
                                           </div>
                                             <div class="col-md-6">
                                                <div class="form-group label-floating" >
                                                   <label class="Label_style">VR Link</label>
                                                   <input type="text" min=0 class="text_box_style form-control" placeholder="Enter VR Link"  formControlName="vr_link" >
                                                </div>
                                             </div>
                                             
                                             <div class="col-sm-12">
                                                <a class="removeIcon mt-3 remove_style" (click)="item.get('variants').removeAt(j)"  *ngIf="item.get('variants').length > 1" > <img src="../../../../assets/img/removeapr.png">  Remove  Variant</a>
                                            </div>
                                            <span class="d-flex w-100 justify-content-center">
 
                                              <span class="d-inline-block w-98 varient-border mt-3">
 
                                              </span>
                                            </span>
                                            
                                       </div>
                                      
 
 
                                       <!-- <div class="col-sm-12">
                                          <a class="removeIcon" (click)="item.get('variants').removeAt(j)"><i class="fa fa-minus-circle mr-1" aria-hidden="true">Remove Last Variant</i></a>
                                      </div> -->
                                       </fieldset>
                                    </div>
                                    <div class="w-100">
                                     <a (click)="addAnotherVariant(item)" class="addIcon varient-add mt-3"><i class="fa fa-plus plus_style " aria-hidden="true"></i></a> <a (click)="addAnotherVariant(item)" class="styling_remove_format">Add Another Variant</a>
                                    </div>
                                  
                                   
                                  </div>
                              </div>
                             
                              <!--Variant Data Format Ends Here-->
                              <!-- <div class="col-sm-12">
                                 <i class="fa fa-minus-circle remove_button" (click)="item.get('variants').removeAt(j)"></i>
                             </div> -->
                             
                           </div>
                     </div>
                     <div class="col-sm-12 mt-2">
                        <a class="removeIcon remove_style  " *ngIf="createApartmentForm.get('formats').length > 1" (click)="createApartmentForm.get('formats').removeAt(i)"><img src="../../../../assets/img/removeapr.png"> Remove  Format</a>
                    </div>
                  </div>
                  <!-- <div class="col-sm-12">
                     <a class="removeIcon" (click)="createApartmentForm.get('format').removeAt(i)"><i class="fa fa-minus-circle mr-1" aria-hidden="true"></i>Remove Last Format</a>
                 </div> -->
                  </fieldset>
               </div>
               <!--Format with varient id and layout image ends here-->
               <a (click)="pushJobAttributes(createApartmentForm)" class="addIcon ml-3 mt-3"><i class="fa fa-plus plus_style " aria-hidden="true"></i></a><a (click)="pushJobAttributes(createApartmentForm)" class="styling_remove_format ml-1 mt-4"> Add Another Format</a>
            </div>
            <div class="d-flex w-100 justify-content-center">
 
             <button type="submit" [disabled]="!createApartmentForm.valid" class="button submit-btn" >Submit</button>
 
            </div>
           
              
            </form>
         </div>
      </div>
   </div>
 </div>
 </div>
 </div>
 <div id="OtherProjectname" class="modal" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered leadQUES"  style="max-width: 50rem !important;"  >
      <!-- Modal content-->
      <div style="border: 3px solid #6F0000;" class="modal-content p-1">
        <div class="modal-header">
          <h6 class="modal-title w-100 text-center"> Add Society/Building/Project </h6>
          <button (click)="closeaddApartmentrplanModal()" type="button" class="close"><i class="fa fa-close"></i></button>
        
        </div>
        <div class="modal-body " (mouseover)="pincodeval()">
          <div class="col-12 row">
            <div  class="form-check d-flex col-12 "  >
              <label   class="customLabel mt-2 col-6">Society/Building/Project Name :<span
                class="text-danger hideAsteriskIcon">*</span></label>
              <input  type="text"  class="form-control col-6" [(ngModel)]="projectName"
                placeholder="Enter the Project name">
            </div>
            <div  class="form-check  d-flex col-12"  >
              <label   class="customLabel mt-2 col-6 ">Developer Name :<span
                class="text-danger hideAsteriskIcon">*</span></label>
              <input type="text"   class="form-control col-6"
                placeholder="Enter the Developer name" [(ngModel)]="DeveloperName">
            </div>
            <div  class="form-check d-flex col-12"  >
              <label   class="customLabel mt-2  col-6">Full Address :<span
                class="text-danger hideAsteriskIcon">*</span></label>
                <input  id="autocomplete-input"  type="text"  class="form-control"    [(ngModel)]="FullAdress" (focus)="pincodeval()" (change)="pincodeval()"
                placeholder="Enter the Full Address">
             
            </div>
            <div  class="form-check  d-flex col-12"  >
              <label   class="customLabel mt-2 col-6">City :<span
                class="text-danger ">*</span></label>
              <input id="citygoogle"  readonly type="text"  class="form-control col-6" >
            </div>
            
            <div  class="form-check d-flex col-12"  >
              <label   class="customLabel mt-2 col-6">Pincode :<span
                class="text-danger ">*</span></label>
              <input id="pincodegoogle"  type="text"   class="form-control col-6"
                 >
                 <input id="areaname" readonly type="text"   class="form-control d-none col-6"
                 >
                 <input id="state" readonly type="text"   class="form-control d-none col-6"
                 >
            </div>
          </div>
          <div class="col-12 mt-2 d-flex justify-content-center">
  
            <button class="btn btn-pink px-3 py-2" [disabled]="projectName == '' || DeveloperName == '' ||  FullAdress == '' || pincodePro == ''   " (click)="Submitapart()">Submit</button>
  
          </div>
        </div>
      </div>
    </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/platform/organisation/add-apartment/createapartment/createapartment.component.html